import { Route, Routes, createRouterPanel } from 'weblite-router'
import { RoomList } from '../room-list'
import { Room } from '../room'
import { Home } from '../home'
import { Profile } from '../profile'
import { RoomProfile } from '../room-profile'
import { Wapp } from '../wapp'
import { WappOverlay } from '../wapp-overlay'
import { ModalViewerOverlay } from '../modal-viewer-overlay'
import { ChatListSearch } from '$comp/_app/components/leftPanel/components/chat-list-search/chat-list-search'
import { Call } from '../call'
import { PvCallManager } from '../pv-call-manager'
import { Vitrine } from '../vitrine'
import { Workbench } from '../workbench'
import { GeneralIssue } from '../general-issue'
import { Story } from '$scenes/story'
import { CourseVitrine } from '$scenes/course-vitrine'

export const RoomListPanel = createRouterPanel(
  'roomList',
  <Routes>
    <Route name="roomList" routeTransitions={{ name: 'zoomFade' }}>
      <Route name="roomList" element={<RoomList />} />
      <Route name="search" element={<ChatListSearch />} />
    </Route>
  </Routes>,
  { location: 'roomList/roomList' },
)

export const ProfilePanel = createRouterPanel('profile', <Profile />)

export const RoomProfilePanel = createRouterPanel(
  'roomProfile',
  <RoomProfile />,
)

export const WorkbenchPanel = createRouterPanel(
  'workbench',
  <Routes>
    <Route name="workbench" element={<Workbench />} />
  </Routes>,
)

export const GeneralIssuePanel = createRouterPanel(
  'general-issue',
  <Routes>
    <Route name="general-issue" element={<GeneralIssue />} />
  </Routes>,
)

export const HomePanel = createRouterPanel(
  'home',
  <Routes>
    <Route name="home" element={<Home />} />
  </Routes>,
  { location: 'home', state: { tab: 'roomList' } },
)

export const RoomPanel = createRouterPanel('room', <Room />, {
  location: 'startPage',
})

export const WappPanel = createRouterPanel(
  'wapp',
  <Routes>
    <Route name="wapp" element={<Wapp />} />
  </Routes>,
)

export const VitrinePanel = createRouterPanel(
  'vitrine',
  <Routes>
    <Route name="vitrine" element={<Vitrine />} />
  </Routes>,
  { location: 'vitrine' },
)
export const CourseVitrinePanel = createRouterPanel(
  'courseVitrine',
  <Routes>
    <Route name="courseVitrine" element={<CourseVitrine />} />
  </Routes>,
  { location: 'courseVitrine' },
)

export const CallPanel = createRouterPanel(
  'call',
  <Routes>
    <Route name="call" element={<Call />} />
  </Routes>,
  { location: 'call' },
)

export const PvCallManagerPanel = createRouterPanel(
  'pvCallManager',
  <Routes>
    <Route name="pvCallManager" element={<PvCallManager />} />
  </Routes>,
  { location: 'pvCallManager' },
)

export const StoryPanel = createRouterPanel(
  'story',
  <Routes>
    <Route name="story" element={<Story />} />
  </Routes>,
  { location: 'story' },
)

export const OverlayWappPanel = createRouterPanel(
  'overlayWapp',
  <Routes>
    <Route name="wapp" element={<WappOverlay />} />
  </Routes>,
)

export const ModalsPanel = createRouterPanel(
  'modals',
  <Routes>
    <Route name="modal" element={<ModalViewerOverlay />} />
  </Routes>,
)
